import styled from '@emotion/styled';

import useGroupProduct from '../../../../../hooks/useGroupProduct';

import type { DealProduct, GroupKey, GroupMember } from '../../../../../types';
import CalendarDropdown from './CalendarDropdown';
import DealProductStepper from '../../../../../shared/DealProductStepper';
import ProductInfoItemWrapper from '../../ProductInfoItemWrapper';

const CalendarDropdownWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
`;

interface Props {
  productNo: number;
  groupKeys: GroupKey[];
  groupMembers: GroupMember[];
  dealProduct: DealProduct;
}

export default function CalendarContent({ productNo, groupKeys, groupMembers, dealProduct }: Props) {
  const { optionList, changeOptionItem } = useGroupProduct({ productNo, groupKeys, groupMembers });

  const optionTitle = optionList.map((option) => option.title).join('·');

  return (
    <>
      <ProductInfoItemWrapper title={`${optionTitle} 선택`} titleLineHeight={40}>
        <CalendarDropdownWrapper>
          {optionList.map((option, index) => (
            <CalendarDropdown
              key={index}
              optionTitle={option.title}
              options={option.options}
              selectedOption={option.selectedOption}
              changeOptionItem={changeOptionItem}
            />
          ))}
        </CalendarDropdownWrapper>
      </ProductInfoItemWrapper>
      <ProductInfoItemWrapper title="구매수량" titleLineHeight={30}>
        <DealProductStepper dealProduct={dealProduct} />
      </ProductInfoItemWrapper>
    </>
  );
}
